var $89aaf803103bb500$exports = {};
$89aaf803103bb500$exports = {
    "longPressMessage": `Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen`
};


export {$89aaf803103bb500$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
